// Get all anchor tags in html string.
export const getAnchors = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  const anchors = div.querySelectorAll("a");

  return Array.from(anchors).map((anchor) => {
    return {
      href: anchor.getAttribute("href"),
      target: anchor.getAttribute("target"),
      text: anchor.innerText,
    };
  });
};
